import React, { useState } from "react";
import * as Select from "@radix-ui/react-select";
import classnames from "classnames";
import {
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "@radix-ui/react-icons";
import "./SelectStyles.css";

const SelectComponent = ({
  items,
  label,
  defaultValue,
  ariaLabel,
  placeholder,
  value,
  onValueChange,
}) => {
  const [selectValue, setSelectValue] = useState(defaultValue || "");

  const handleValueChange = (newValue) => {
    setSelectValue(newValue);
    onValueChange(newValue);
  };
  const formattedValue = items.reduce((accum, item) => {
    accum[item.value] = item.label;
    return accum;
  }, {})[selectValue];

  return (
    <Select.Root value={selectValue} onValueChange={handleValueChange}>
      <Select.Trigger className="SelectTrigger" aria-label={ariaLabel}>
        <Select.Value aria-label={value} placeholder={placeholder}>
          {formattedValue}
        </Select.Value>
        <Select.Icon className="SelectIcon">
          <ChevronDownIcon />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content className="SelectContent">
          <Select.ScrollUpButton className="SelectScrollButton">
            <ChevronUpIcon />
          </Select.ScrollUpButton>
          <Select.Viewport className="SelectViewport">
            {items.map((item, i) => (
              <SelectItem key={item.value + item.label + i} value={item.value}>
                <Select.ItemText>{item.label}</Select.ItemText>
              </SelectItem>
            ))}
          </Select.Viewport>
          <Select.ScrollDownButton className="SelectScrollButton">
            <ChevronDownIcon />
          </Select.ScrollDownButton>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};

const SelectItem = React.forwardRef(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <Select.Item
        className={classnames("SelectItem", className)}
        {...props}
        ref={forwardedRef}
      >
        <Select.ItemText>{children}</Select.ItemText>
        <Select.ItemIndicator className="SelectItemIndicator">
          <CheckIcon />
        </Select.ItemIndicator>
      </Select.Item>
    );
  }
);

export default SelectComponent;
